import React from 'react'
import { Surface } from '@/components/admin/atoms/layout/Surface'
import { Padding } from '@/components/admin/atoms/layout/Padding'
import { Stack } from '@/components/admin/atoms/layout/Stack'
import { Divider } from '@/components/admin/atoms/layout/Divider'
import { Text } from '@/components/admin/atoms/typography/Text'

interface FormSectionProps {
  title?: string
  children: React.ReactNode
  padding?: '5' | '6'
  className?: never
}

export const FormSection: React.FC<FormSectionProps> = ({
  title, children, padding = '6',
}) => (
  <Surface variant="card" radius="lg">
    <Padding all={padding}>
      <Stack gap="4">
        {title && (
          <>
            <Text size="sm" weight="semibold">{title}</Text>
            <Divider />
          </>
        )}
        {children}
      </Stack>
    </Padding>
  </Surface>
)
